exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-c7073188]:export{menuText:#bfcbd9;menuActiveText:#409EFF;subMenuActiveText:#f4f4f5;menuBg:#304156;menuHover:#263445;subMenuBg:#1f2d3d;subMenuHover:#001528;sideBarWidth:210px;bgColor:#F2F3F5;fontColor:#409EFF;searchBg:#fff}.handing-all-btn[data-v-c7073188]{margin-left:20px;margin-top:16px}.inquiry-table[data-v-c7073188]{margin-top:16px}.pagination[data-v-c7073188]{margin-top:12px;text-align:right}[data-v-c7073188] .el-table__body td{padding:8px 0 !important;height:40px !important}\n", ""]);

// exports
